import axios from "axios";
import { Loading, Message } from 'element-ui';
import store from '@/store/index'
import route from '@/router/index'




var loading = null
let needLoadingRequestCount = 0

function startLoading() {
    loading = Loading.service({
        lock: true,
        text: '加载中...',
        fullscreen: true,
        background: 'rgba(0,0,0,0.7)'
    })
}

function endLoading() {
    loading.close()
}

function showfullLoading() {
    startLoading()
    needLoadingRequestCount++
}


function tryHideLoading() {
    needLoadingRequestCount--
    needLoadingRequestCount == 0 ? endLoading() : ''
}

const link_Url = 'https://www.ctt88.com/api'


const service = axios.create({
    baseURL: link_Url,
    timeout: 15000,
    headers: {
        get: { 'Content-Type': 'application/x-www-form-urlencoded;' },
        post: { 'Content-Type': 'application/json;' }
    }
})

const refresh_obj = {
    pro: null,
}

const refresh = function (headers) {
    if (refresh_obj.pro) return refresh_obj.pro;
    refresh_obj.pro = new Promise((resolve, reject) => {
        axios.post(link_Url + '/auth/refresh', {r: Math.random() }, {
            headers: headers
        }).then((res) => {
            refresh_obj.pro = null;
            let resdata = res.data;
            window.localStorage.setItem('token', JSON.stringify(resdata.data))
            resolve(resdata.data);
        }).catch((err) => {
            resolve("");
        });
    })
    return refresh_obj.pro;
}


// 请求拦截器

service.interceptors.request.use(async config => {
    // 添加 token
    let _token = JSON.parse(window.localStorage.getItem('token'))
    if (_token) {
        config.headers.Authorization = 'Bearer ' + _token.access_token
        let expires_at = new Date(_token.expires_at);
        let newdata = new Date();
        if (newdata.getTime() > (expires_at.getTime() + _token.expires_in * 1000)) {
            let token = await refresh({
                'Authorization': 'Bearer ' + _token.access_token,
                'Content-Type': 'application/json',
            });
            if (token) config.headers.Authorization = 'Bearer ' + token.access_token;
        }
    }
    //添加 Loading
    if (config.ShowLoading) showfullLoading()
    return config;
}, Error => {
    tryHideLoading()
    return Promise.reject(Error)
})

// 响应拦截器
service.interceptors.response.use(response => {
    // 清除 Loading
    if (response.config.ShowLoading) tryHideLoading()
    return response.data;
}, Error => {
    if (Error.response.status == '401') {
		needLoadingRequestCount = 0;
		if(loading) loading.close()
        Message.error('登陸狀態已失效，請重新登錄！')
        window.localStorage.clear('islogin')
        window.localStorage.clear('userinfo')
        window.localStorage.clear('token')
        store.dispatch("CunisLogin", 0)
        route.push({
            name: 'Login'
        })
    }else{
		tryHideLoading()
	}
    return Promise.reject(Error.response.data)
})


export {
    service,
    link_Url
}

// export导出要 {}
// export default 则不要
